import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

import type {
  DrawerState,
  PersistableRightDrawerContent,
} from '../types/drawer'

export async function persistDrawerState(value: DrawerState): Promise<void> {
  if (value.direction === 'initial') {
    return
  }

  const url = window.Silverfin.Routes.toggle_sidepane_open_users_path(
    window.Silverfin.currentFirmId,
    { content: value.content, position: value.direction }
  )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot persist drawer state', {
      error: e,
    })
  }
}

export async function persistLeftDrawerCollapsed(
  value: boolean
): Promise<void> {
  const url = window.Silverfin.Routes.update_left_drawer_collapsed_users_path(
    window.Silverfin.currentFirmId,
    { value }
  )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot persist left drawer collapsed state', { error: e })
  }
}

export async function persistRightDrawerContent(
  value: PersistableRightDrawerContent
): Promise<void> {
  const url = window.Silverfin.Routes.update_right_drawer_content_users_path(
    window.Silverfin.currentFirmId,
    { content: value ?? '' }
  )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot persist right drawer content', { error: e })
  }
}

export async function persistSidepaneOpenCompletedTodosState(
  value: boolean
): Promise<void> {
  const url =
    window.Silverfin.Routes.update_sidepane_open_completed_todos_users_path(
      window.Silverfin.currentFirmId,
      { value }
    )

  try {
    await SFetch.jsonWithAlert(url, { method: 'POST' })
  } catch (e) {
    SfLog.error('Cannot persist sidepane open completed todos state', {
      error: e,
    })
  }
}
